module.exports = __webpack_public_path__ + "static/Banner-24-b0890b3c0c2036c93241f11dd60c5e44.png";